import { Suspense } from "react";
import { useLoaderData, useOutlet, Await } from "react-router-dom";
import { Alert } from "antd";
import { AuthProvider } from "./AuthProvider";
import Cookies from "js-cookie";

export const getUserData = () =>
  new Promise((resolve) => {
    const user = Cookies.get("nbk-token");
    // console.log("[GET USER DATA", user, user || null);
    resolve(user || null);
  });

export const AuthLayout = () => {
  const outlet = useOutlet();

  const { userPromise } = useLoaderData();

  return (
    <Suspense>
      <Await
        resolve={userPromise}
        errorElement={<Alert severity="error">Something went wrong!</Alert>}
        children={(user) => {
          // console.log("FIN await ", user);
          return <AuthProvider userData={user}>{outlet}</AuthProvider>;
        }}
      />
    </Suspense>
  );
};
